<template>
  <div>
    <!-- <GroupList :accessToken="accessToken" />
    <div class="column">
      <button class="button is-warning is-fullwidth" @click="fullLogout()">
        <span class="icon">
          <i class="fas fa-door-open fa-fw" />
        </span>
        <span>Logout (Full)</span>
      </button>
    </div>-->
    <div class="crm-top cases-top">
      <div class="cases-top-left">
        <div class="case-tabs">
            <div class="case-tab case-tab-klijenti active">Stranke</div>
            <div class="case-tab case-tab-potencijalni">Potencijalne stranke</div>
            <div class="case-tab case-tab-analitika">Analitika-izvještaji</div>
        </div>
      </div>
      <div class="cases-top-right">
        <div class="add-case">Kreiraj klijenta<div class="add-plus"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"><g><g><path fill="#fff" d="M10.346 7.733H7.741v2.606a1.737 1.737 0 1 1-3.474 0V7.733H1.662a1.737 1.737 0 0 1 0-3.476h2.605V1.651a1.737 1.737 0 1 1 3.474 0v2.606h2.605a1.737 1.737 0 0 1 0 3.476z"/></g></g></svg></div></div>
      </div>
      <div class="crm-line">
        <div class="letter-search">
          <div class="ls active">A</div>
          <div class="ls">B</div>
          <div class="ls">C</div>
          <div class="ls">Č</div>
          <div class="ls">Ć</div>
          <div class="ls active">D</div>
          <div class="ls active">DŽ</div>
          <div class="ls">Đ</div>
          <div class="ls">E</div>
          <div class="ls">F</div>
          <div class="ls">G</div>
          <div class="ls">H</div>
          <div class="ls">I</div>
          <div class="ls">J</div>
          <div class="ls">K</div>
          <div class="ls">L</div>
          <div class="ls active">LJ</div>
          <div class="ls">M</div>
          <div class="ls">N</div>
          <div class="ls">NJ</div>
          <div class="ls">O</div>
          <div class="ls">P</div>
          <div class="ls active">R</div>
          <div class="ls">S</div>
          <div class="ls">Š</div>
          <div class="ls">T</div>
          <div class="ls">U</div>
          <div class="ls">V</div>
          <div class="ls">Z</div>
          <div class="ls">Ž</div>
        </div>
        <div class="crm-search"><input type="text" placeholder="Pretraži.."><div class="top-search-button"><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><g><g><path fill="#fff" d="M25.714 25.714a.952.952 0 0 1-1.346 0l-6.295-6.295A10.95 10.95 0 0 1 11 21.999C4.925 22 0 17.076 0 11 0 4.926 4.925 0 11 0s11 4.926 11 11c0 2.696-.972 5.161-2.581 7.074l6.295 6.295a.952.952 0 0 1 0 1.346zM20 11a9 9 0 1 0-18 0 9 9 0 0 0 18 0z"/></g></g></svg></div></div>
        <div class="crm-dropdown">
          Prikaz:
           <select id="search-group">
            <option value="sve">Prikaži sve</option>
            <option value="ugovor">Način plaćanja: Ugovor</option>
            <option value="tarifa">Način plaćanja: Tarifa</option>
            <option value="ove-godine">Datum upisa: Ove godine</option>
            <option value="posljednji-mjesec">Datum upisa: Posljednji mjesec</option>
            <option value="privatna-osoba">Privatna osoba</option>
            <option value="pravna-osoba">Pravna osoba</option>
          </select>
          <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg">
        </div>
      </div>
    </div>
    <div class="crm-main-wrapper cases-main-wrapper">
      <div class="cases-row row-title-row">
        <div class="cases-column cases-column1">Klijent<div class="downarrow"></div></div>
        <div class="cases-column cases-column2">Datum upisa<div class="downarrow"></div></div>
        <div class="cases-column cases-column3">Upisan od<div class="downarrow"></div></div>
        <div class="cases-column cases-column4">Zadužen kod<div class="downarrow"></div></div>
        <div class="cases-column cases-column5">Grad<div class="downarrow"></div></div>
        <div class="cases-column cases-column6">Telefon<div class="downarrow"></div></div>
        <div class="cases-column cases-column7">Način plaćanja<div class="downarrow"></div></div>
      </div>
        
      <div class="cases-row">
        <div class="cases-column cases-column1"><a href="#">Akrapović Darinka</a></div>
        <div class="cases-column cases-column2"><a href="#">22.03.2009.</a></div>
        <div class="cases-column cases-column3"><a href="#">Suzana Cesarec</a></div>
        <div class="cases-column cases-column4"><a href="#">Marko Porobija</a></div>
        <div class="cases-column cases-column5">Metković</div>
        <div class="cases-column cases-column6">099 224 855</div>
        <div class="cases-column cases-column7">Tarifa</div>
      </div>
      <div class="cases-row">
        <div class="cases-column cases-column1"><a href="#">Antolić Ivan</a></div>
        <div class="cases-column cases-column2"><a href="#">17.01.2014.</a></div>
        <div class="cases-column cases-column3"><a href="#">Dubravka Črnila</a></div>
        <div class="cases-column cases-column4"><a href="#">Maja Kauzler-Geček</a></div>
        <div class="cases-column cases-column5">Sveti Ivan Zelina</div>
        <div class="cases-column cases-column6">091 585 82 46</div>
        <div class="cases-column cases-column7">Tarifa</div>
      </div>
      <div class="cases-row">
        <div class="cases-column cases-column1"><a href="#">Dandrić-Perišić Tomislav</a></div>
        <div class="cases-column cases-column2"><a href="#">28.01.2020.</a></div>
        <div class="cases-column cases-column3"><a href="#">Maja Kauzler-Geček</a></div>
        <div class="cases-column cases-column4"><a href="#">Maja Kauzler-Geček</a></div>
        <div class="cases-column cases-column5">Varaždin</div>
        <div class="cases-column cases-column6">091 945 39 58</div>
        <div class="cases-column cases-column7">Tarifa</div>
      </div>
      <div class="cases-row">
        <div class="cases-column cases-column1"><a href="#">Drakulić Mislav</a></div>
        <div class="cases-column cases-column2"><a href="#">22.06.2005.</a></div>
        <div class="cases-column cases-column3"><a href="#">Suzana Cesarec</a></div>
        <div class="cases-column cases-column4"><a href="#">Marko Porobija</a></div>
        <div class="cases-column cases-column5">Biograd na Moru</div>
        <div class="cases-column cases-column6">095 438 48 89</div>
        <div class="cases-column cases-column7">Tarifa</div>
      </div>
      <div class="cases-row last-row">
        <div class="cases-column cases-column1"><a href="#">Džaja Petra</a></div>
        <div class="cases-column cases-column2"><a href="#">14.09.2011.</a></div>
        <div class="cases-column cases-column3"><a href="#">Dubravka Črnila</a></div>
        <div class="cases-column cases-column4"><a href="#">Dmitar Tar</a></div>
        <div class="cases-column cases-column5">Zagreb</div>
        <div class="cases-column cases-column6">098 243 57 65</div>
        <div class="cases-column cases-column7">Ugovor</div>
      </div>
    </div>
    <div class="cases-pagination">
      <div class="cases-pagination-left"><img style="width:20rem;" src="@/assets/img/paginacija.png"></div>
      <div class="cases-pagination-right">
        Broj redova po stranici 
        <div class="broj-redova">
          <select id="search-group">
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
          </select>
          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11"><g><g><path fill="#3326ae" d="M.204 3.503a.754.754 0 0 0 .572.264c.18 0 .354-.065.506-.196l1.816-1.828L4.92 3.571c.142.142.33.22.53.22.202 0 .39-.078.533-.22a.76.76 0 0 0 0-1.065L3.632.14A.748.748 0 0 0 3.1-.077c-.2 0-.388.077-.53.22L.203 2.522a.754.754 0 0 0 0 .98z"/></g><g><path fill="#3326ae" d="M6.026 7.411a.758.758 0 0 0-1.083-.067L3.12 9.17 1.291 7.343a.75.75 0 0 0-.532-.22.75.75 0 0 0-.534.221.757.757 0 0 0 0 1.065l2.36 2.364a.752.752 0 0 0 .533.219c.201 0 .39-.078.534-.22l2.374-2.38a.752.752 0 0 0 0-.98z"/></g></g></svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from "@/services/auth";
import GroupList from "@/components/generalComponents/GroupList";
import predmet_hand from "@/apiCallers/promise_handler_db/predmeti";
import share  from "@/apiCallers/sharepoint";
import moment from "moment"
export default {
  components: { GroupList },
  data() {
    return {
      accessToken: "",
      dohvaceni_predmeti : [],
      fiz_protustranke : [],
      fiz_stranke : [],
      broj_predmeta : 5,
      data_loaded : false
    };
  },
  async created() {
    this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
    share.getAll(this.accessToken).then((response)=>{
      console.log(response.data);
    })
     predmet_hand.getAll(this.accessToken).then((response)=>{
       console.log(response.data.dohvaceni_predmeti[0].broj_predmeta)
      this.dohvaceni_predmeti = response.data.dohvaceni_predmeti;
      this.fiz_protustranke = response.data.fiz_protustranke;
      this.fiz_stranke = response.data.fiz_stranke
      this.data_loaded = true
    })
    // this.addNewGroup();
    // console.log(this.accessToken)
  },

  methods: {
    switchDate(inData){
      
     return moment(inData.toString()).format('l');
    },
    getYear(inData){
      
     return moment(inData.toString()).format("YYYY");
    },
    fullLogout() {
      auth.clearLocal();
      auth.logout();
      this.$router.push({ path: "/login" });
    },

    addNewGroup() {
      var tempGroup = {
        description: "Grupa iz vue-a",
        displayName: "Slučaj Tomm i Jerry",
        groupTypes: ["Unified"],
        mailEnabled: true,
        visibility : "Hiddenmembership",
        mailNickname: "Oznaka_01",
        securityEnabled: false,
      };
      var resp = null
      share.addNewGroup(this.accessToken, tempGroup).then((response)=>
      {
        console.log(response)
        resp = response;
      })
    },
  },
  mounted() {
   this.$store.state.paginacija.title = "Upravljanje strankama"
   
  },
};
</script>

<style>
</style>